import React from "react";
import googleBuss from "../../assets/images/logos/google-buss.svg";
import vrboImage from "../../assets/images/logos/vrbo.svg";
import agodaImage from "../../assets/images/logos/agoda.svg";
import airbnbImage from "../../assets/images/logos/airbnb.svg";
import bookingImage from "../../assets/images/logos/booking.svg";
import tripAdvisorImage from "../../assets/images/logos/trip-advisor.png";
import mmtImage from "../../assets/images/logos/mmt.svg";

const IndustryLeaders = () => {
  return (
    <>
      <section className="clients-row">
        <div className="max-container">
          <div className="grid-auto-fit align-items-center">
            <div className="text-center">
              <img src={airbnbImage} alt="Clients" className="img-responsive" />
            </div>

            <div className="text-center">
              <img
                src={tripAdvisorImage}
                alt="Clients"
                className="img-responsive"
              />
            </div>

            <div className="text-center">
              <img src={googleBuss} alt="Clients" className="img-responsive" />
            </div>

            <div className="text-center">
              <img src={vrboImage} alt="Clients" className="img-responsive" />
            </div>

            <div className="text-center">
              <img src={agodaImage} alt="Clients" className="img-responsive" />
            </div>

            <div className="text-center">
              <img
                src={bookingImage}
                alt="Clients"
                className="img-responsive"
              />
            </div>

            <div className="text-center">
              <img src={mmtImage} alt="Clients" className="img-responsive" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IndustryLeaders;
